import { getBulkModerationStatusesForEmailRpc, getBulkModerationStatusesForFormRpc, getBulkModerationStatusesForWebpageRpc, getModerationStatusForEmailRpc, getModerationStatusForFormRpc, getModerationStatusForWebpageRpc } from '../../__generated__/chirp/com/hubspot/abusedesk/rpc/PublicContentCaseRpc';
export const SINGLE_RPC_MAP = {
  email: getModerationStatusForEmailRpc,
  webpage: getModerationStatusForWebpageRpc,
  form: getModerationStatusForFormRpc
};
export const BULK_RPC_MAP = {
  email: getBulkModerationStatusesForEmailRpc,
  webpage: getBulkModerationStatusesForWebpageRpc,
  form: getBulkModerationStatusesForFormRpc
};